<script>
import { NavigationsAuthorized } from 'data';
import { filterPagesByAttributes, extractChildren } from 'utils';

import { checkGeneralPermition, checkSubscribedFeaturePermissions, checkScopesPermitionAndRequiredSubscribedFeature } from 'utils/check-permissions';

import ReturnQuery from 'components/mixins/return-query';

import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';

import NuttremaStatusLabel from 'components/ui/label/nuttrema-status-label';
import ElMenuItemNotAllowed from 'components/ui/navigation/nuttrema-el-menu-item-not-allowed';

export default {
  mixins: [ReturnQuery],
  props: {
    id: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaMenuList,
    NuttremaStatusLabel,
    NuttremaMenuListItem,
    ElMenuItemNotAllowed,
  },
  data() {
    return {
      startingUrl: null,
      navigationLinks: NavigationsAuthorized,
    };
  },
  computed: {
    navigations() {
      const result = [];
      const auth = this.$auth;
      const pages = this.startingUrl ? extractChildren(el => el.url === this.startingUrl, this.navigationLinks, 'pages') : this.navigationLinks;
      filterPagesByAttributes(el => (el && el.scope ? auth.check(el.scope) : true), pages, result);
      return result;
    },
  },
  methods: {
    checkGeneralPermition,
    checkSubscribedFeaturePermissions,
    checkScopesPermitionAndRequiredSubscribedFeature,
    handleOpen() {},
    handleClose() {},
    gotoPageByName(page) {
      this.$router.push({ name: page.name });
    },
    gotoPageByPath(page) {
      this.$router.push({ path: page.path });
    },
    replaceID(value) {
      return value.replace(/{id}/g, this.id);
    },
  },
};
</script>

<style lang="scss">
@import './sidebar-menu';
</style>



// WEBPACK FOOTER //
// src/components/ui/menu/sidebar-menu.vue